(function () {
  var COOKIE = "markup_pct";
  var STORAGE_PREFIX = "dealer_markup_";
  var UNLOCK_KEY = "dealer_markup_unlocked";
  var DEFAULT_PASSWORD = "12345678";
  var PRICE_SELECTOR = "[data-price-cents], .price-item, span.money";

  function parsePct(value) {
    var n = parseFloat(value);
    if (!isFinite(n) || n < 0) return 0;
    return n;
  }

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
    );
    return match ? decodeURIComponent(match[1]) : "";
  }

  function setCookie(name, value) {
    document.cookie =
      name + "=" + encodeURIComponent(value) + "; path=/; max-age=31536000; SameSite=Lax";
  }

  function deleteCookie(name) {
    document.cookie = name + "=; path=/; max-age=0; SameSite=Lax";
  }

  function storageKey(customerId) {
    return STORAGE_PREFIX + (customerId || "guest");
  }

  function readStoredPct(customerId) {
    try {
      var raw = window.localStorage.getItem(storageKey(customerId));
      if (!raw) return 0;
      var data = JSON.parse(raw);
      return parsePct(data && data.pct);
    } catch (e) {
      return 0;
    }
  }

  function writeStoredPct(customerId, pct) {
    window.localStorage.setItem(storageKey(customerId), JSON.stringify({ pct: parsePct(pct) }));
  }

  function isUnlocked() {
    try {
      return window.localStorage.getItem(UNLOCK_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function setUnlocked(on) {
    try {
      if (on) window.localStorage.setItem(UNLOCK_KEY, "1");
      else window.localStorage.removeItem(UNLOCK_KEY);
    } catch (e) {}
  }

  function applyPct(customerId, pct) {
    var n = parsePct(pct);
    writeStoredPct(customerId, n);
    if (n > 0) {
      setCookie(COOKIE, String(n));
    } else {
      deleteCookie(COOKIE);
    }
    return n;
  }

  function showError(form, message) {
    var el = form.querySelector("[data-dealer-markup-error]");
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.hidden = false;
    } else {
      el.textContent = "";
      el.hidden = true;
    }
  }

  function expectedPassword() {
    if (config.password != null && String(config.password) !== "") {
      return String(config.password);
    }
    return DEFAULT_PASSWORD;
  }

  function passwordMatches(form) {
    if (isUnlocked()) return true;
    var input = form.querySelector("[data-dealer-markup-password]");
    var entered = input && input.value ? String(input.value) : "";
    return entered === expectedPassword();
  }

  function syncPasswordField(form) {
    var wrap = form.querySelector("[data-dealer-markup-password-wrap]");
    if (wrap) wrap.hidden = isUnlocked();
  }

  function parseMoneyToCents(text) {
    if (!text) return null;
    var cleaned = String(text).replace(/[^0-9.,-]/g, "");
    if (!cleaned) return null;
    if (cleaned.indexOf(",") > -1 && cleaned.indexOf(".") > -1) {
      cleaned = cleaned.replace(/,/g, "");
    } else if (cleaned.indexOf(",") > -1) {
      var parts = cleaned.split(",");
      if (parts[parts.length - 1].length === 2) {
        cleaned = parts.slice(0, -1).join("") + "." + parts[parts.length - 1];
      } else {
        cleaned = cleaned.replace(/,/g, "");
      }
    }
    var num = parseFloat(cleaned);
    if (!isFinite(num)) return null;
    return Math.round(num * 100);
  }

  var config = window.dealerMarkup || {};
  var customerId = config.customerId ? String(config.customerId) : "guest";
  var storedPct = readStoredPct(customerId);
  var cookiePct = parsePct(getCookie(COOKIE) || config.cookiePct);

  if (cookiePct > 0 || storedPct > 0) setUnlocked(true);

  var pct = cookiePct > 0 ? cookiePct : storedPct;
  var factor = pct > 0 ? 1 + pct / 100 : 1;
  var applying = false;
  var originalFormatMoney =
    window.Shopify && typeof Shopify.formatMoney === "function"
      ? Shopify.formatMoney.bind(Shopify)
      : null;

  function formatCents(cents) {
    if (!originalFormatMoney) return String(cents / 100);
    return originalFormatMoney(cents, window.money_format || Shopify.money_format);
  }

  if (factor > 1 && originalFormatMoney) {
    Shopify.formatMoney = function (cents, format) {
      if (cents == null || cents === "") {
        return originalFormatMoney(cents, format);
      }
      var amount = cents;
      if (typeof amount === "string") {
        amount = amount.replace(".", "");
      }
      amount = Number(amount);
      if (!isFinite(amount)) {
        return originalFormatMoney(cents, format);
      }
      return originalFormatMoney(Math.round(amount * factor), format);
    };
  }

  function applyElement(el) {
    if (!el || !el.closest) return;
    if (el.closest("[data-dealer-markup-form]")) return;
    if (el.getAttribute("data-price-cents") === "") return;

    if (!el.hasAttribute("data-original-html")) {
      el.setAttribute("data-original-html", el.innerHTML);
    }

    var originalHtml = el.getAttribute("data-original-html") || "";
    var centsAttr = el.getAttribute("data-price-cents") || el.getAttribute("data-original-cents");
    var cents = centsAttr !== null && centsAttr !== "" ? parseInt(centsAttr, 10) : null;
    if (!isFinite(cents)) {
      cents = parseMoneyToCents(originalHtml.replace(/<[^>]+>/g, " "));
      if (cents != null) el.setAttribute("data-original-cents", String(cents));
    }

    if (cents == null || !isFinite(cents)) return;

    var nextHtml = originalHtml;
    if (factor > 1) {
      var marked = formatCents(Math.round(cents * factor));
      var originalMoney = formatCents(cents);
      if (originalHtml.indexOf(originalMoney) !== -1) {
        nextHtml = originalHtml.split(originalMoney).join(marked);
      } else {
        nextHtml = marked;
      }
    }

    if (el.innerHTML !== nextHtml) {
      el.innerHTML = nextHtml;
    }
  }

  function applyAllPrices() {
    if (applying) return;
    applying = true;
    try {
      document.querySelectorAll(PRICE_SELECTOR).forEach(applyElement);
    } finally {
      applying = false;
    }
  }

  function fillInput(input) {
    if (!input) return;
    if (pct > 0) {
      input.value = String(pct);
      return;
    }
    if (storedPct > 0) {
      input.value = String(storedPct);
    }
  }

  function bindForm(form) {
    var input = form.querySelector("[data-dealer-markup-input]");
    fillInput(input);
    syncPasswordField(form);

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      showError(form, "");
      if (!passwordMatches(form)) {
        showError(form, "Incorrect password");
        return;
      }
      setUnlocked(true);
      applyPct(customerId, input ? input.value : 0);
      window.location.reload();
    });

    var resetBtn = form.querySelector("[data-dealer-markup-reset]");
    if (resetBtn) {
      resetBtn.addEventListener("click", function (event) {
        event.preventDefault();
        showError(form, "");
        if (input) input.value = "0";
        setUnlocked(false);
        applyPct(customerId, 0);
        window.location.reload();
      });
    }
  }

  document.addEventListener("click", function (event) {
    var link = event.target.closest('a[href*="/account/logout"]');
    if (!link) return;
    setUnlocked(false);
    deleteCookie(COOKIE);
  });

  function initForms() {
    document.querySelectorAll("[data-dealer-markup-form]").forEach(bindForm);
  }

  applyAllPrices();

  if (document.body) {
    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(applyAllPrices, 50);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initForms();
      applyAllPrices();
    });
  } else {
    initForms();
    applyAllPrices();
  }
})();
